import * as React from 'react'

const XlsIcon = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  ({ ...props }, ref) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      ref={ref}
      {...props}
    >
      <g clipPath="url(#clip0_7337_43594)">
        <path
          fill="#E9F0FA"
          d="m18 0 4 4v19a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1z"
        ></path>
        <path fill="#C2CDDE" d="M22 4h-4V0z"></path>
      </g>
      <rect width="22" height="10" x="1" y="10" fill="#0F8105" rx="1"></rect>
      <path
        fill="#fff"
        d="m5.83 12.182 1.28 2.13h.046l1.287-2.13h1.202L7.852 15.09 9.673 18H8.452l-1.296-2.117h-.045L5.815 18H4.6l1.838-2.91-1.815-2.908zM10.472 18v-5.818h1.054v4.934h2.563V18zm7.694-4.219a.78.78 0 0 0-.336-.58q-.293-.207-.761-.207-.33 0-.565.1a.84.84 0 0 0-.361.27.66.66 0 0 0-.046.704.75.75 0 0 0 .23.228q.146.09.321.153t.356.105l.545.136q.329.077.634.208.306.13.548.33.244.198.386.48t.142.658q0 .512-.261.901-.261.387-.756.605-.491.216-1.19.216-.68 0-1.18-.21a1.76 1.76 0 0 1-.777-.614q-.28-.403-.302-.983h1.037a.9.9 0 0 0 .188.506q.165.201.429.301.267.1.596.1.344 0 .603-.103a1 1 0 0 0 .409-.29.7.7 0 0 0 .15-.437.56.56 0 0 0-.133-.375 1 1 0 0 0-.367-.25 3.5 3.5 0 0 0-.545-.182l-.662-.17q-.72-.185-1.137-.56-.414-.378-.414-1.003a1.5 1.5 0 0 1 .278-.9 1.84 1.84 0 0 1 .764-.6 2.65 2.65 0 0 1 1.094-.216q.62 0 1.085.216.47.213.736.594.267.378.276.87z"
      ></path>
      <defs>
        <clipPath id="clip0_7337_43594">
          <path fill="#fff" d="M2 0h20v24H2z"></path>
        </clipPath>
      </defs>
    </svg>
  ),
)

XlsIcon.displayName = 'XlsIcon'

export { XlsIcon }
